export class DirtyInTasks {
  public items: DirtyInTaskItem[];
  public sharekeys: { [sharekey_id: string]: string };
}
export class DirtyInTaskItem {
  public hist_id: number;
  public id: number;
  public pid: number;
  public sharename_digest: string;
  public enc_share_name: string;
  public sharekey_id: string;
  public share_id: number;
  public share_sequence: number;
}

export class DirtyInTaskResult {
  public id: number;
  public pid: number;
  public enc_name: string;
  public hist_id: number;
  public share_id: number;
  public sharename_digest: string;
}
